<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th v-for="(column, index) in columns" :key="index">
            {{ column.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td v-for="(column, colIndex) in columns" :key="index + '-' + colIndex">
            <template>
              <slot :name="column.name" :row-data="item"></slot>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  props: {
    columns: {
      type: Array
    },
    data: {
      type: Array
    }
  }
}
</script>
<style scoped>
.table {
  overflow: auto;
  padding-bottom: 100px;
  max-width: 1500px;
}
table {
  width: 100%;
}
th {
  background-color: #deebf7;
  color: #808080;
}
th, td {
  text-align: center;
  padding: 5px 10px;
  border: 1px solid #ccc;
  min-width: 50px;
}
td {
  background-color: #fff;
  .max-content {
    width: max-content;
    margin: 0 auto;
  }
}
th:first-child, td:first-child {
  text-align: left;
  min-width: 400px;
  max-width: 600px;
}

</style>



// WEBPACK FOOTER //
// src/view/sale/components/BaseTable.vue